// <auto-generated>
// This file is automatically generated from DSL.
// Do not modify this file directly. Changes will be overwritten.
// Generated: 2026-04-11T10:42:45.816Z
// </auto-generated>

import AccountBalance from '@mui/icons-material/AccountBalance';
import AccountBox from '@mui/icons-material/AccountBox';
import AccountTree from '@mui/icons-material/AccountTree';
import Add from '@mui/icons-material/Add';
import AdminPanelSettings from '@mui/icons-material/AdminPanelSettings';
import Approval from '@mui/icons-material/Approval';
import Apps from '@mui/icons-material/Apps';
import Business from '@mui/icons-material/Business';
import Cable from '@mui/icons-material/Cable';
import Calculate from '@mui/icons-material/Calculate';
import CallMade from '@mui/icons-material/CallMade';
import Category from '@mui/icons-material/Category';
import Checklist from '@mui/icons-material/Checklist';
import Dataset from '@mui/icons-material/Dataset';
import Description from '@mui/icons-material/Description';
import Email from '@mui/icons-material/Email';
import Engineering from '@mui/icons-material/Engineering';
import Folder from '@mui/icons-material/Folder';
import Groups from '@mui/icons-material/Groups';
import Handshake from '@mui/icons-material/Handshake';
import History from '@mui/icons-material/History';
import Inbox from '@mui/icons-material/Inbox';
import Inventory from '@mui/icons-material/Inventory';
import Inventory2 from '@mui/icons-material/Inventory2';
import LocalShipping from '@mui/icons-material/LocalShipping';
import MenuBook from '@mui/icons-material/MenuBook';
import Outbox from '@mui/icons-material/Outbox';
import People from '@mui/icons-material/People';
import PersonAdd from '@mui/icons-material/PersonAdd';
import Place from '@mui/icons-material/Place';
import Policy from '@mui/icons-material/Policy';
import Receipt from '@mui/icons-material/Receipt';
import ReceiptLong from '@mui/icons-material/ReceiptLong';
import Schedule from '@mui/icons-material/Schedule';
import Search from '@mui/icons-material/Search';
import Settings from '@mui/icons-material/Settings';
import ShoppingCart from '@mui/icons-material/ShoppingCart';
import SwapHoriz from '@mui/icons-material/SwapHoriz';
import SyncAlt from '@mui/icons-material/SyncAlt';
import TableChart from '@mui/icons-material/TableChart';
import TaskAlt from '@mui/icons-material/TaskAlt';
import TrendingUp from '@mui/icons-material/TrendingUp';
import Tune from '@mui/icons-material/Tune';
import VpnKey from '@mui/icons-material/VpnKey';
import type { SvgIconComponent } from '@mui/icons-material';

/**
 * Navigation menu item
 */
export interface NavigationMenuItem {
  id: string;
  entity?: string;
  /**
   * Module owning the entity (set on every entity item). It differs from the module the item is
   * listed under when the entity declares `navigation.menuModule`; paths, permissions and page
   * context follow the owner.
   */
  module?: string;
  /**
   * Field holding the record's business identity, e.g. 'orderNumber'. Same value the
   * detail view puts in its page heading, so anything labelling a record at runtime
   * shows the identity the user is already looking at.
   */
  displayField?: string;
  viewId?: string;
  label: string;
  labelKey?: string;
  path: string;
  icon?: SvgIconComponent;
  order: number;
  viewType: 'list' | 'inquiry' | 'report' | 'dashboard' | 'form';
  filter?: Record<string, any>;
  permission?: string;
  /**
   * Offered as a default landing page in User Settings, to users who may see this item.
   * Generated from the entity's `navigation.landingPage`; a hand-written item sets it itself.
   */
  landingPage?: boolean;
}

/**
 * Navigation category
 */
export interface NavigationCategory {
  id: string;
  label: string;
  labelKey?: string;
  icon: SvgIconComponent;
  order: number;
  items: NavigationMenuItem[];
}

/**
 * Quick action button
 */
export interface QuickAction {
  id: string;
  action: 'create' | 'command';
  label: string;
  labelKey?: string;
  icon: SvgIconComponent;
  path?: string;
  command?: string;
  permission?: string;
}

/**
 * Module navigation configuration
 */
export interface ModuleNavigationConfig {
  module: string;
  label: string;
  labelKey?: string;
  icon: SvgIconComponent;
  quickActions: QuickAction[];
  categories: NavigationCategory[];
}

/**
 * Hierarchical module navigation configuration
 */
export const moduleNavigation: ModuleNavigationConfig[] = [
  {
    module: 'Administration',
    label: 'System Administration',
    labelKey: 'Menu:Administration',
    icon: AdminPanelSettings,
    quickActions: [],
    categories: [
      {
        id: 'configuration',
        label: 'Configuration',
        labelKey: 'Menu:Administration.Category.Configuration',
        icon: Tune,
        order: 2,
        items: [
        {
          id: 'orgunit_list',
          entity: 'OrgUnit',
          module: 'Core',
          displayField: 'name',
          label: 'Org Units (Admin)',
          labelKey: 'Menu:Core.OrgUnits(Admin)',
          path: '/core/orgunits',
          icon: Business,
          order: 5,
          viewType: 'list',
          permission: 'Core.OrgUnit.Update',
        },
        {
          id: 'enumvalue',
          entity: 'EnumValue',
          module: 'Core',
          displayField: 'displayName',
          label: 'Enum Values',
          labelKey: 'Menu:Core.EnumValue',
          path: '/core/enumvalues',
          order: 50,
          viewType: 'list',
          permission: 'Core.EnumValue.ViewMenu',
        }
        ],
      },
      {
        id: 'operations',
        label: 'Operations',
        labelKey: 'Menu:Administration.Category.Operations',
        icon: Engineering,
        order: 4,
        items: [
        {
          id: 'batchjob',
          entity: 'BatchJob',
          module: 'Core',
          displayField: 'name',
          label: 'Batch Jobs',
          labelKey: 'Menu:Core.BatchJob',
          path: '/core/batchjobs',
          icon: Schedule,
          order: 50,
          viewType: 'list',
          permission: 'Core.BatchJob.ViewMenu',
        },
        {
          id: 'entitytemplate',
          entity: 'EntityTemplate',
          module: 'Core',
          displayField: 'entityName',
          label: 'Entity Templates',
          labelKey: 'Menu:Core.EntityTemplate',
          path: '/core/entitytemplates',
          icon: Description,
          order: 90,
          viewType: 'list',
          permission: 'Core.EntityTemplate.ViewMenu',
        },
        {
          id: 'setuppackage',
          entity: 'SetupPackage',
          module: 'Core',
          displayField: 'moduleName',
          label: 'Setup Packages',
          labelKey: 'Menu:Core.SetupPackage',
          path: '/core/setuppackages',
          icon: Inventory2,
          order: 95,
          viewType: 'list',
          permission: 'Core.SetupPackage.ViewMenu',
        }
        ],
      }
    ],
  },
  {
    module: 'Core',
    label: 'Core',
    labelKey: 'Menu:Core',
    icon: Dataset,
    quickActions: [],
    categories: [
      {
        id: 'records',
        label: 'Masterdata',
        labelKey: 'Menu:Core.Category.Masterdata',
        icon: AccountBox,
        order: 1,
        items: [
        {
          id: 'country',
          entity: 'Country',
          module: 'Core',
          displayField: 'name',
          label: 'Countries',
          labelKey: 'Menu:Core.Country',
          path: '/core/countries',
          order: 50,
          viewType: 'list',
          permission: 'Core.Country.ViewMenu',
        },
        {
          id: 'currency',
          entity: 'Currency',
          module: 'Core',
          displayField: 'name',
          label: 'Currencies',
          labelKey: 'Menu:Core.Currency',
          path: '/core/currencies',
          order: 50,
          viewType: 'list',
          permission: 'Core.Currency.ViewMenu',
        },
        {
          id: 'deliveryterms',
          entity: 'DeliveryTerms',
          module: 'Core',
          displayField: 'name',
          label: 'Delivery Terms',
          labelKey: 'Menu:Core.DeliveryTerms',
          path: '/core/deliveryterms',
          order: 50,
          viewType: 'list',
          permission: 'Core.DeliveryTerms.ViewMenu',
        },
        {
          id: 'orgrolefunction',
          entity: 'OrgRoleFunction',
          module: 'Core',
          displayField: 'name',
          label: 'Org Role Functions',
          labelKey: 'Menu:Core.OrgRoleFunction',
          path: '/core/orgrolefunctions',
          order: 50,
          viewType: 'list',
          permission: 'Core.OrgRoleFunction.ViewMenu',
        },
        {
          id: 'paymentterms',
          entity: 'PaymentTerms',
          module: 'Core',
          displayField: 'name',
          label: 'Payment Terms',
          labelKey: 'Menu:Core.PaymentTerms',
          path: '/core/paymentterms',
          order: 50,
          viewType: 'list',
          permission: 'Core.PaymentTerms.ViewMenu',
        },
        {
          id: 'tradetype',
          entity: 'TradeType',
          module: 'Core',
          displayField: 'name',
          label: 'Trade Types',
          labelKey: 'Menu:Core.TradeType',
          path: '/core/tradetypes',
          order: 50,
          viewType: 'list',
          permission: 'Core.TradeType.ViewMenu',
        },
        {
          id: 'unitofmeasure',
          entity: 'UnitOfMeasure',
          module: 'Core',
          displayField: 'name',
          label: 'Unit Of Measures',
          labelKey: 'Menu:Core.UnitOfMeasure',
          path: '/core/unitofmeasures',
          order: 50,
          viewType: 'list',
          permission: 'Core.UnitOfMeasure.ViewMenu',
        },
        {
          id: 'areatype',
          entity: 'AreaType',
          module: 'Core',
          displayField: 'name',
          label: 'Area Types',
          labelKey: 'Menu:Core.AreaType',
          path: '/core/areatypes',
          icon: Description,
          order: 270,
          viewType: 'list',
          permission: 'Core.AreaType.ViewMenu',
        },
        {
          id: 'assignmentpolicy',
          entity: 'AssignmentPolicy',
          module: 'Core',
          displayField: 'entityType',
          label: 'Assignment Policies',
          labelKey: 'Menu:Core.AssignmentPolicy',
          path: '/core/assignmentpolicies',
          icon: Description,
          order: 280,
          viewType: 'list',
          permission: 'Core.AssignmentPolicy.ViewMenu',
        },
        {
          id: 'area',
          entity: 'Area',
          module: 'Core',
          displayField: 'name',
          label: 'Areas',
          labelKey: 'Menu:Core.Area',
          path: '/core/areas',
          icon: Description,
          order: 290,
          viewType: 'list',
          permission: 'Core.Area.ViewMenu',
        },
        {
          id: 'llddistrict',
          entity: 'LldDistrict',
          module: 'Core',
          displayField: 'name',
          label: 'LLD Districts',
          labelKey: 'Menu:Core.LldDistrict',
          path: '/core/llddistricts',
          icon: Description,
          order: 290,
          viewType: 'list',
          permission: 'Core.LldDistrict.ViewMenu',
        },
        {
          id: 'receivinglocation',
          entity: 'ReceivingLocation',
          module: 'Core',
          displayField: 'name',
          label: 'Receiving Locations',
          labelKey: 'Menu:Core.ReceivingLocation',
          path: '/core/receivinglocations',
          icon: Description,
          order: 310,
          viewType: 'list',
          permission: 'Core.ReceivingLocation.ViewMenu',
        }
        ],
      },
      {
        id: 'configuration',
        label: 'Configuration',
        labelKey: 'Menu:Core.Category.Configuration',
        icon: Tune,
        order: 2,
        items: [
        {
          id: 'orgunit',
          entity: 'OrgUnit',
          module: 'Core',
          displayField: 'name',
          label: 'Organization',
          labelKey: 'Menu:Core.OrgUnit',
          path: '/core/organization',
          icon: AccountTree,
          order: 5,
          viewType: 'list',
          permission: 'Core.OrgUnit.ViewMenu',
        }
        ],
      },
      {
        id: 'setup',
        label: 'Setup',
        labelKey: 'Menu:Core.Category.Setup',
        icon: Folder,
        order: 50,
        items: [
        {
          id: 'ownerderivationrule',
          entity: 'OwnerDerivationRule',
          module: 'Core',
          displayField: 'entityType',
          label: 'Owner Derivation Rules',
          labelKey: 'Menu:Core.OwnerDerivationRule',
          path: '/core/ownerderivationrules',
          icon: Description,
          order: 20,
          viewType: 'list',
          permission: 'Core.OwnerDerivationRule.ViewMenu',
        }
        ],
      },
      {
        id: 'settings',
        label: 'Settings',
        labelKey: 'Menu:Core.Category.Settings',
        icon: Settings,
        order: 99,
        items: [
        {
          id: 'companyprofile',
          entity: 'CompanyProfile',
          module: 'Core',
          displayField: 'orgNumber',
          label: 'Company Details',
          labelKey: 'Menu:Core.CompanyProfile',
          path: '/core/companyprofiles',
          order: 45,
          viewType: 'list',
          permission: 'Core.CompanyProfile.ViewMenu',
        },
        {
          id: 'documenttemplate',
          entity: 'DocumentTemplate',
          module: 'Core',
          displayField: 'name',
          label: 'Document Templates',
          labelKey: 'Menu:Core.DocumentTemplate',
          path: '/core/documenttemplates',
          order: 50,
          viewType: 'list',
          permission: 'Core.DocumentTemplate.ViewMenu',
        },
        {
          id: 'numberseries',
          entity: 'NumberSeries',
          module: 'Core',
          displayField: 'name',
          label: 'Number Series',
          labelKey: 'Menu:Core.NumberSeries',
          path: '/core/numberseries',
          order: 50,
          viewType: 'list',
          permission: 'Core.NumberSeries.ViewMenu',
        },
        {
          id: 'documentpagesetup',
          entity: 'DocumentPageSetup',
          module: 'Core',
          displayField: 'name',
          label: 'Document Page Setups',
          labelKey: 'Menu:Core.DocumentPageSetup',
          path: '/core/documentpagesetups',
          order: 51,
          viewType: 'list',
          permission: 'Core.DocumentPageSetup.ViewMenu',
        }
        ],
      }
    ],
  },
  {
    module: 'Finance',
    label: 'Finance',
    labelKey: 'Menu:Finance',
    icon: AccountBalance,
    quickActions: [],
    categories: [
      {
        id: 'records',
        label: 'General Ledger',
        labelKey: 'Menu:Finance.Category.GeneralLedger',
        icon: MenuBook,
        order: 1,
        items: [
        {
          id: 'account',
          entity: 'Account',
          module: 'Finance',
          displayField: 'accountNumber',
          label: 'Accounts',
          labelKey: 'Menu:Finance.Account',
          path: '/finance/accounts',
          icon: Description,
          order: 10,
          viewType: 'list',
          permission: 'Finance.Account.ViewMenu',
        },
        {
          id: 'hierarchy_financeaccountgroup',
          entity: 'FinanceAccountGroup',
          module: 'Finance',
          label: 'Account Groups',
          labelKey: 'Menu:Finance.AccountGroups',
          path: '/finance/financeaccountgroups',
          icon: AccountTree,
          order: 20,
          viewType: 'list',
          permission: 'Finance.FinanceAccountGroup.ViewMenu',
        },
        {
          id: 'vatcode',
          entity: 'VatCode',
          module: 'Finance',
          displayField: 'name',
          label: 'VAT Codes',
          labelKey: 'Menu:Finance.VatCode',
          path: '/finance/vatcodes',
          icon: Description,
          order: 30,
          viewType: 'list',
          permission: 'Finance.VatCode.ViewMenu',
        },
        {
          id: 'fiscalyear',
          entity: 'FiscalYear',
          module: 'Finance',
          displayField: 'name',
          label: 'Fiscal Years',
          labelKey: 'Menu:Finance.FiscalYear',
          path: '/finance/fiscalyears',
          icon: Description,
          order: 40,
          viewType: 'list',
          permission: 'Finance.FiscalYear.ViewMenu',
        },
        {
          id: 'dimensionset',
          entity: 'DimensionSet',
          module: 'Finance',
          displayField: 'hash',
          label: 'Dimension Sets',
          labelKey: 'Menu:Finance.DimensionSet',
          path: '/finance/dimensionsets',
          order: 50,
          viewType: 'list',
          permission: 'Finance.DimensionSet.ViewMenu',
        },
        {
          id: 'fiscalperiod',
          entity: 'FiscalPeriod',
          module: 'Finance',
          displayField: 'name',
          label: 'Fiscal Periods',
          labelKey: 'Menu:Finance.FiscalPeriod',
          path: '/finance/fiscalperiods',
          icon: Description,
          order: 50,
          viewType: 'list',
          permission: 'Finance.FiscalPeriod.ViewMenu',
        }
        ],
      },
      {
        id: 'budget',
        label: 'Budget & Planning',
        labelKey: 'Menu:Finance.Category.Budget&Planning',
        icon: TrendingUp,
        order: 2,
        items: [
        {
          id: 'planscenario',
          entity: 'PlanScenario',
          module: 'Finance',
          displayField: 'name',
          label: 'Plan Scenarios',
          labelKey: 'Menu:Finance.PlanScenario',
          path: '/finance/planscenarios',
          icon: Description,
          order: 40,
          viewType: 'list',
          permission: 'Finance.PlanScenario.ViewMenu',
        },
        {
          id: 'planversion',
          entity: 'PlanVersion',
          module: 'Finance',
          displayField: 'label',
          label: 'Plan Versions',
          labelKey: 'Menu:Finance.PlanVersion',
          path: '/finance/planversions',
          icon: Description,
          order: 50,
          viewType: 'list',
          permission: 'Finance.PlanVersion.ViewMenu',
        },
        {
          id: 'planheader',
          entity: 'PlanHeader',
          module: 'Finance',
          displayField: 'name',
          label: 'Plan Headers',
          labelKey: 'Menu:Finance.PlanHeader',
          path: '/finance/planheaders',
          icon: Description,
          order: 52,
          viewType: 'list',
          permission: 'Finance.PlanHeader.ViewMenu',
        },
        {
          id: 'planversionpublishrun',
          entity: 'PlanVersionPublishRun',
          module: 'Finance',
          displayField: 'correlationId',
          label: 'Plan Publish Runs',
          labelKey: 'Menu:Finance.PlanVersionPublishRun',
          path: '/finance/planversionpublishruns',
          icon: History,
          order: 55,
          viewType: 'list',
          permission: 'Finance.PlanVersionPublishRun.ViewMenu',
        },
        {
          id: 'planlinereevaluationrun',
          entity: 'PlanLineReevaluationRun',
          module: 'Finance',
          displayField: 'runNumber',
          label: 'Plan Re-evaluation Runs',
          labelKey: 'Menu:Finance.PlanLineReevaluationRun',
          path: '/finance/planlinereevaluationruns',
          icon: History,
          order: 56,
          viewType: 'list',
          permission: 'Finance.PlanLineReevaluationRun.ViewMenu',
        },
        {
          id: 'planline',
          entity: 'PlanLine',
          module: 'Finance',
          displayField: 'notes',
          label: 'Plan Lines',
          labelKey: 'Menu:Finance.PlanLine',
          path: '/finance/planlines',
          icon: Description,
          order: 60,
          viewType: 'list',
          permission: 'Finance.PlanLine.ViewMenu',
        },
        {
          id: 'planview',
          entity: 'PlanView',
          module: 'Finance',
          displayField: 'name',
          label: 'Plan Views',
          labelKey: 'Menu:Finance.PlanView',
          path: '/finance/planviews',
          icon: Description,
          order: 70,
          viewType: 'list',
          permission: 'Finance.PlanView.ViewMenu',
        },
        {
          id: 'planstatementtemplate',
          entity: 'PlanStatementTemplate',
          module: 'Finance',
          displayField: 'name',
          label: 'Report Templates',
          labelKey: 'Menu:Finance.PlanStatementTemplate',
          path: '/finance/planstatementtemplates',
          icon: Description,
          order: 71,
          viewType: 'list',
          permission: 'Finance.PlanStatementTemplate.ViewMenu',
        },
        {
          id: 'distributionprofile',
          entity: 'DistributionProfile',
          module: 'Finance',
          displayField: 'name',
          label: 'Distribution Profiles',
          labelKey: 'Menu:Finance.DistributionProfile',
          path: '/finance/distributionprofiles',
          icon: Description,
          order: 80,
          viewType: 'list',
          permission: 'Finance.DistributionProfile.ViewMenu',
        },
        {
          id: 'accountderivationrule',
          entity: 'AccountDerivationRule',
          module: 'Finance',
          displayField: 'notes',
          label: 'Account Derivation Rules',
          labelKey: 'Menu:Finance.AccountDerivationRule',
          path: '/finance/accountderivationrules',
          icon: Description,
          order: 100,
          viewType: 'list',
          permission: 'Finance.AccountDerivationRule.ViewMenu',
        }
        ],
      },
      {
        id: 'dimensions',
        label: 'Dimensions',
        labelKey: 'Menu:Finance.Category.Dimensions',
        icon: Tune,
        order: 3,
        items: [
        {
          id: 'dimensiondefinition',
          entity: 'DimensionDefinition',
          module: 'Finance',
          displayField: 'name',
          label: 'Dimension Definitions',
          labelKey: 'Menu:Finance.DimensionDefinition',
          path: '/finance/dimensiondefinitions',
          icon: Description,
          order: 10,
          viewType: 'list',
          permission: 'Finance.DimensionDefinition.ViewMenu',
        },
        {
          id: 'dimensionvalue',
          entity: 'DimensionValue',
          module: 'Finance',
          displayField: 'name',
          label: 'Dimension Values',
          labelKey: 'Menu:Finance.DimensionValue',
          path: '/finance/dimensionvalues',
          icon: Description,
          order: 20,
          viewType: 'list',
          permission: 'Finance.DimensionValue.ViewMenu',
        },
        {
          id: 'accountdimensionrule',
          entity: 'AccountDimensionRule',
          module: 'Finance',
          displayField: 'id',
          label: 'Account Dimension Rules',
          labelKey: 'Menu:Finance.AccountDimensionRule',
          path: '/finance/accountdimensionrules',
          icon: Description,
          order: 30,
          viewType: 'list',
          permission: 'Finance.AccountDimensionRule.ViewMenu',
        }
        ],
      },
      {
        id: 'settings',
        label: 'Settings',
        labelKey: 'Menu:Finance.Category.Settings',
        icon: Settings,
        order: 99,
        items: [
        {
          id: 'setupflow_budgetsetup',
          module: 'Finance',
          label: 'Budget & Plan Readiness',
          labelKey: 'Menu:Finance.BudgetSetup',
          path: '/finance/setup/budget-setup',
          icon: Checklist,
          order: 5,
          viewType: 'form',
          permission: 'Finance.SetupFlow.BudgetSetup',
        }
        ],
      }
    ],
  },
  {
    module: 'Forestry',
    label: 'Forestry',
    labelKey: 'Menu:Forestry',
    icon: Apps,
    quickActions: [
      {
        id: 'agreement_create',
        action: 'create',
        label: 'New Agreement',
        labelKey: 'QuickAction:Agreement.create',
        icon: Add,
        path: '/forestry/agreements/new',
        permission: 'Forestry.Agreement.Create',
      }
    ],
    categories: [
      {
        id: 'records',
        label: 'Masterdata',
        labelKey: 'Menu:Forestry.Category.Masterdata',
        icon: AccountBox,
        order: 1,
        items: [
        {
          id: 'agreement',
          entity: 'Agreement',
          module: 'Forestry',
          displayField: 'agreementNumber',
          label: 'Agreements',
          labelKey: 'Menu:Forestry.Agreement',
          path: '/forestry/agreements',
          icon: Description,
          order: 50,
          viewType: 'list',
          permission: 'Forestry.Agreement.ViewMenu',
        },
        {
          id: 'contract',
          entity: 'Contract',
          module: 'Forestry',
          displayField: 'contractNumber',
          label: 'Contracts',
          labelKey: 'Menu:Forestry.Contract',
          path: '/forestry/contracts',
          icon: Description,
          order: 50,
          viewType: 'list',
          permission: 'Forestry.Contract.ViewMenu',
        },
        {
          id: 'organization',
          entity: 'Organization',
          module: 'Forestry',
          displayField: 'name',
          label: 'Organizations',
          labelKey: 'Menu:Forestry.Organization',
          path: '/forestry/organizations',
          icon: Description,
          order: 50,
          viewType: 'list',
          permission: 'Forestry.Organization.ViewMenu',
        },
        {
          id: 'workorder',
          entity: 'Workorder',
          module: 'Forestry',
          displayField: 'workorderNumber',
          label: 'Workorders',
          labelKey: 'Menu:Forestry.Workorder',
          path: '/forestry/workorders',
          icon: ShoppingCart,
          order: 50,
          viewType: 'list',
          permission: 'Forestry.Workorder.ViewMenu',
        }
        ],
      },
      {
        id: 'calculation',
        label: 'Calculation',
        labelKey: 'Menu:Forestry.Category.Calculation',
        icon: Calculate,
        order: 2,
        items: [
        {
          id: 'precalculation',
          entity: 'PreCalculation',
          module: 'Forestry',
          displayField: 'preCalculationNumber',
          label: 'Pre Calculations',
          labelKey: 'Menu:Forestry.PreCalculation',
          path: '/forestry/precalculations',
          icon: Description,
          order: 40,
          viewType: 'list',
          permission: 'Forestry.PreCalculation.ViewMenu',
        },
        {
          id: 'calculationtemplate',
          entity: 'CalculationTemplate',
          module: 'Forestry',
          displayField: 'name',
          label: 'Calculation Templates',
          labelKey: 'Menu:Forestry.CalculationTemplate',
          path: '/forestry/calculationtemplates',
          icon: Description,
          order: 170,
          viewType: 'list',
          permission: 'Forestry.CalculationTemplate.ViewMenu',
        },
        {
          id: 'calculationcomponent',
          entity: 'CalculationComponent',
          module: 'Forestry',
          displayField: 'name',
          label: 'Calculation Components',
          labelKey: 'Menu:Forestry.CalculationComponent',
          path: '/forestry/calculationcomponents',
          icon: Description,
          order: 190,
          viewType: 'list',
          permission: 'Forestry.CalculationComponent.ViewMenu',
        },
        {
          id: 'pricedimension',
          entity: 'PriceDimension',
          module: 'Forestry',
          displayField: 'name',
          label: 'Price Dimensions',
          labelKey: 'Menu:Forestry.PriceDimension',
          path: '/forestry/pricedimensions',
          icon: Description,
          order: 250,
          viewType: 'list',
          permission: 'Forestry.PriceDimension.ViewMenu',
        },
        {
          id: 'priceareaassortment',
          entity: 'PriceAreaAssortment',
          module: 'Forestry',
          displayField: 'id',
          label: 'Price Area Assortments',
          labelKey: 'Menu:Forestry.PriceAreaAssortment',
          path: '/forestry/priceareaassortments',
          icon: Description,
          order: 260,
          viewType: 'list',
          permission: 'Forestry.PriceAreaAssortment.ViewMenu',
        },
        {
          id: 'pricedimensionclasscombination',
          entity: 'PriceDimensionClassCombination',
          module: 'Forestry',
          displayField: 'hash',
          label: 'Price Dimension Class Combinations',
          labelKey: 'Menu:Forestry.PriceDimensionClassCombination',
          path: '/forestry/pricedimensionclasscombinations',
          icon: Description,
          order: 270,
          viewType: 'list',
          permission: 'Forestry.PriceDimensionClassCombination.ViewMenu',
        }
        ],
      },
      {
        id: 'transactions',
        label: 'Transactions',
        labelKey: 'Menu:Forestry.Category.Transactions',
        icon: SwapHoriz,
        order: 3,
        items: [
        {
          id: 'loadobservation',
          entity: 'LoadObservation',
          module: 'Forestry',
          displayField: 'id',
          label: 'Load observations',
          labelKey: 'Menu:Forestry.LoadObservation',
          path: '/forestry/loadobservations',
          icon: Place,
          order: 50,
          viewType: 'list',
          permission: 'Forestry.LoadObservation.ViewMenu',
        }
        ],
      },
      {
        id: 'settings',
        label: 'Settings',
        labelKey: 'Menu:Forestry.Category.Settings',
        icon: Settings,
        order: 99,
        items: [
        {
          id: 'setupflow_precalculationsetup',
          module: 'Forestry',
          label: 'Pre-calculation Readiness',
          labelKey: 'Menu:Forestry.PreCalculationSetup',
          path: '/forestry/setup/pre-calculation-setup',
          icon: Checklist,
          order: 5,
          viewType: 'form',
          permission: 'Forestry.SetupFlow.PreCalculationSetup',
        },
        {
          id: 'costtype',
          entity: 'CostType',
          module: 'Forestry',
          displayField: 'name',
          label: 'Cost Types',
          labelKey: 'Menu:Forestry.CostType',
          path: '/forestry/costtypes',
          icon: Description,
          order: 200,
          viewType: 'list',
          permission: 'Forestry.CostType.ViewMenu',
        }
        ],
      }
    ],
  },
  {
    module: 'Integration',
    label: 'Integration',
    labelKey: 'Menu:Integration',
    icon: SyncAlt,
    quickActions: [],
    categories: [
      {
        id: 'messages',
        label: 'Messages',
        labelKey: 'Menu:Integration.Category.Messages',
        icon: Email,
        order: 1,
        items: [
        {
          id: 'integrationstagingrecord',
          entity: 'IntegrationStagingRecord',
          module: 'Integration',
          displayField: 'originalFileName',
          label: 'Inbound Messages',
          labelKey: 'Menu:Integration.IntegrationStagingRecord',
          path: '/integration/integrationstagingrecords',
          icon: Inbox,
          order: 10,
          viewType: 'list',
          permission: 'Integration.IntegrationStagingRecord.ViewMenu',
        },
        {
          id: 'integrationoutboxrecord',
          entity: 'IntegrationOutboxRecord',
          module: 'Integration',
          displayField: 'documentNumber',
          label: 'Outbound Messages',
          labelKey: 'Menu:Integration.IntegrationOutboxRecord',
          path: '/integration/integrationoutboxrecords',
          icon: Outbox,
          order: 20,
          viewType: 'list',
          permission: 'Integration.IntegrationOutboxRecord.ViewMenu',
        },
        {
          id: 'integrationcallrecord',
          entity: 'IntegrationCallRecord',
          module: 'Integration',
          displayField: 'callNumber',
          label: 'External Calls',
          labelKey: 'Menu:Integration.IntegrationCallRecord',
          path: '/integration/integrationcallrecords',
          icon: CallMade,
          order: 30,
          viewType: 'list',
          permission: 'Integration.IntegrationCallRecord.ViewMenu',
        }
        ],
      },
      {
        id: 'administration',
        label: 'Administration',
        labelKey: 'Menu:Integration.Category.Administration',
        icon: Folder,
        order: 50,
        items: [
        {
          id: 'integrationconnection',
          entity: 'IntegrationConnection',
          module: 'Integration',
          displayField: 'name',
          label: 'Integration Connections',
          labelKey: 'Menu:Integration.IntegrationConnection',
          path: '/integration/integrationconnections',
          icon: Cable,
          order: 30,
          viewType: 'list',
          permission: 'Integration.IntegrationConnection.ViewMenu',
        },
        {
          id: 'integrationjob',
          entity: 'IntegrationJob',
          module: 'Integration',
          displayField: 'name',
          label: 'Integration Jobs',
          labelKey: 'Menu:Integration.IntegrationJob',
          path: '/integration/integrationjobs',
          icon: SyncAlt,
          order: 31,
          viewType: 'list',
          permission: 'Integration.IntegrationJob.ViewMenu',
        },
        {
          id: 'importprofile',
          entity: 'ImportProfile',
          module: 'Integration',
          displayField: 'name',
          label: 'Import Profiles',
          labelKey: 'Menu:Integration.ImportProfile',
          path: '/integration/importprofiles',
          icon: TableChart,
          order: 32,
          viewType: 'list',
          permission: 'Integration.ImportProfile.ViewMenu',
        },
        {
          id: 'integrationclient',
          entity: 'IntegrationClient',
          module: 'Integration',
          displayField: 'name',
          label: 'Integration Clients',
          labelKey: 'Menu:Integration.IntegrationClient',
          path: '/integration/integrationclients',
          icon: VpnKey,
          order: 32,
          viewType: 'list',
          permission: 'Integration.IntegrationClient.ViewMenu',
        },
        {
          id: 'integrationrun',
          entity: 'IntegrationRun',
          module: 'Integration',
          displayField: 'targetEntity',
          label: 'Integration Runs',
          labelKey: 'Menu:Integration.IntegrationRun',
          path: '/integration/integrationruns',
          icon: History,
          order: 35,
          viewType: 'list',
          permission: 'Integration.IntegrationRun.ViewMenu',
        }
        ],
      },
      {
        id: 'settings',
        label: 'Settings',
        labelKey: 'Menu:Integration.Category.Settings',
        icon: Settings,
        order: 99,
        items: [

        ],
      }
    ],
  },
  {
    module: 'Inventory',
    label: 'Inventory',
    labelKey: 'Menu:Inventory',
    icon: Inventory,
    quickActions: [
      {
        id: 'product_create',
        action: 'create',
        label: 'New Stock Item',
        labelKey: 'QuickAction:Product.create',
        icon: Add,
        path: '/inventory/products/new',
        permission: 'Inventory.Product.Create',
      }
    ],
    categories: [
      {
        id: 'transactions',
        label: 'Transactions',
        labelKey: 'Menu:Inventory.Category.Transactions',
        icon: SwapHoriz,
        order: 1,
        items: [
        {
          id: 'inventorytransaction',
          entity: 'InventoryTransaction',
          module: 'Inventory',
          displayField: 'locationCode',
          label: 'Inventory Transactions',
          labelKey: 'Menu:Inventory.InventoryTransaction',
          path: '/inventory/inventorytransactions',
          order: 20,
          viewType: 'list',
          permission: 'Inventory.InventoryTransaction.ViewMenu',
        },
        {
          id: 'inventoryreservation',
          entity: 'InventoryReservation',
          module: 'Inventory',
          displayField: 'sourceId',
          label: 'Reservations',
          labelKey: 'Menu:Inventory.InventoryReservation',
          path: '/inventory/inventoryreservations',
          order: 30,
          viewType: 'list',
          permission: 'Inventory.InventoryReservation.ViewMenu',
        }
        ],
      },
      {
        id: 'records',
        label: 'Masterdata',
        labelKey: 'Menu:Inventory.Category.Masterdata',
        icon: AccountBox,
        order: 2,
        items: [
        {
          id: 'product',
          entity: 'Product',
          module: 'Inventory',
          displayField: 'productNumber',
          label: 'Stock Items',
          labelKey: 'Menu:Inventory.Product',
          path: '/inventory/products',
          icon: Category,
          order: 10,
          viewType: 'list',
          permission: 'Inventory.Product.ViewMenu',
        },
        {
          id: 'hierarchy_inventoryproductgroup',
          entity: 'InventoryProductGroup',
          module: 'Inventory',
          label: 'Product Groups',
          labelKey: 'Menu:Inventory.ProductGroups',
          path: '/inventory/inventoryproductgroups',
          icon: Category,
          order: 25,
          viewType: 'list',
          permission: 'Inventory.InventoryProductGroup.ViewMenu',
        }
        ],
      },
      {
        id: 'inquiries',
        label: 'Inquiries',
        labelKey: 'Menu:Inventory.Category.Inquiries',
        icon: Search,
        order: 5,
        items: [
        {
          id: 'product_inquiry',
          entity: 'Product',
          module: 'Inventory',
          displayField: 'productNumber',
          label: 'Item Availability',
          labelKey: 'Menu:Inventory.ItemAvailability',
          path: '/inventory/products',
          order: 10,
          viewType: 'inquiry',
          permission: 'Inventory.Product.ViewMenu',
        }
        ],
      },
      {
        id: 'processes',
        label: 'Processes',
        labelKey: 'Menu:Inventory.Category.Processes',
        icon: AccountTree,
        order: 7,
        items: [
        {
          id: 'inventoryperiodclose',
          entity: 'InventoryPeriodClose',
          module: 'Inventory',
          displayField: 'period',
          label: 'Period Close',
          labelKey: 'Menu:Inventory.InventoryPeriodClose',
          path: '/inventory/inventoryperiodcloses',
          order: 10,
          viewType: 'list',
          permission: 'Inventory.InventoryPeriodClose.ViewMenu',
        }
        ],
      },
      {
        id: 'settings',
        label: 'Settings',
        labelKey: 'Menu:Inventory.Category.Settings',
        icon: Settings,
        order: 99,
        items: [
        {
          id: 'inventorypostingprofile',
          entity: 'InventoryPostingProfile',
          module: 'Inventory',
          displayField: 'accountCode',
          label: 'Posting Profiles',
          labelKey: 'Menu:Inventory.InventoryPostingProfile',
          path: '/inventory/inventorypostingprofiles',
          order: 20,
          viewType: 'list',
          permission: 'Inventory.InventoryPostingProfile.ViewMenu',
        },
        {
          id: 'standardcostversion',
          entity: 'StandardCostVersion',
          module: 'Inventory',
          displayField: 'versionCode',
          label: 'Standard Cost Versions',
          labelKey: 'Menu:Inventory.StandardCostVersion',
          path: '/inventory/standardcostversions',
          order: 30,
          viewType: 'list',
          permission: 'Inventory.StandardCostVersion.ViewMenu',
        }
        ],
      }
    ],
  },
  {
    module: 'Pricing',
    label: 'Pricing',
    labelKey: 'Menu:Pricing',
    icon: Apps,
    quickActions: [],
    categories: [
      {
        id: 'records',
        label: 'Masterdata',
        labelKey: 'Menu:Pricing.Category.Masterdata',
        icon: AccountBox,
        order: 1,
        items: [
        {
          id: 'pricelist',
          entity: 'PriceList',
          module: 'Pricing',
          displayField: 'name',
          label: 'Price Lists',
          labelKey: 'Menu:Pricing.PriceList',
          path: '/pricing/pricelists',
          order: 40,
          viewType: 'list',
          permission: 'Pricing.PriceList.ViewMenu',
        },
        {
          id: 'internalpricelist',
          entity: 'InternalPriceList',
          module: 'Pricing',
          displayField: 'name',
          label: 'Internal Price Lists',
          labelKey: 'Menu:Pricing.InternalPriceList',
          path: '/pricing/internalpricelists',
          order: 41,
          viewType: 'list',
          permission: 'Pricing.InternalPriceList.ViewMenu',
        }
        ],
      },
      {
        id: 'settings',
        label: 'Settings',
        labelKey: 'Menu:Pricing.Category.Settings',
        icon: Settings,
        order: 99,
        items: [

        ],
      }
    ],
  },
  {
    module: 'Procurement',
    label: 'Procurement',
    labelKey: 'Menu:Procurement',
    icon: Receipt,
    quickActions: [
      {
        id: 'supplier_create',
        action: 'create',
        label: 'New Supplier',
        labelKey: 'QuickAction:Supplier.create',
        icon: Add,
        path: '/procurement/suppliers/new',
        permission: 'Procurement.Supplier.Create',
      }
    ],
    categories: [
      {
        id: 'records',
        label: 'Masterdata',
        labelKey: 'Menu:Procurement.Category.Masterdata',
        icon: AccountBox,
        order: 1,
        items: [
        {
          id: 'supplier',
          entity: 'Supplier',
          module: 'Procurement',
          displayField: 'supplierNumber',
          label: 'Suppliers',
          labelKey: 'Menu:Procurement.Supplier',
          path: '/procurement/suppliers',
          icon: LocalShipping,
          order: 55,
          viewType: 'list',
          permission: 'Procurement.Supplier.ViewMenu',
        }
        ],
      },
      {
        id: 'transactions',
        label: 'Transactions',
        labelKey: 'Menu:Procurement.Category.Transactions',
        icon: SwapHoriz,
        order: 50,
        items: [
        {
          id: 'inboundmeasuringticket',
          entity: 'InboundMeasuringTicket',
          module: 'Procurement',
          displayField: 'measuringTicketNumber',
          label: 'Inbound Measuring Tickets',
          labelKey: 'Menu:Procurement.InboundMeasuringTicket',
          path: '/procurement/inboundmeasuringtickets',
          icon: ReceiptLong,
          order: 60,
          viewType: 'list',
          permission: 'Procurement.InboundMeasuringTicket.ViewMenu',
        }
        ],
      },
      {
        id: 'settings',
        label: 'Settings',
        labelKey: 'Menu:Procurement.Category.Settings',
        icon: Settings,
        order: 99,
        items: [

        ],
      }
    ],
  },
  {
    module: 'Sales',
    label: 'Sales',
    labelKey: 'Menu:Sales',
    icon: Handshake,
    quickActions: [
      {
        id: 'customer_create',
        action: 'create',
        label: 'New Customer',
        labelKey: 'QuickAction:Customer.create',
        icon: PersonAdd,
        path: '/sales/customers/new',
        permission: 'Sales.Customer.Create',
      },
      {
        id: 'customergroup_create',
        action: 'create',
        label: 'New Customer Group',
        labelKey: 'QuickAction:CustomerGroup.create',
        icon: Add,
        path: '/sales/customergroups/new',
        permission: 'Sales.CustomerGroup.Create',
      },
      {
        id: 'order_create',
        action: 'create',
        label: 'New Order',
        labelKey: 'QuickAction:Order.create',
        icon: Add,
        path: '/sales/orders/new',
        permission: 'Sales.Order.Create',
      }
    ],
    categories: [
      {
        id: 'transactions',
        label: 'Transactions',
        labelKey: 'Menu:Sales.Category.Transactions',
        icon: SwapHoriz,
        order: 1,
        items: [
        {
          id: 'order',
          entity: 'Order',
          module: 'Sales',
          displayField: 'orderNumber',
          label: 'Orders',
          labelKey: 'Menu:Sales.Order',
          path: '/sales/orders',
          icon: ShoppingCart,
          order: 10,
          viewType: 'list',
          permission: 'Sales.Order.ViewMenu',
        },
        {
          id: 'invoice',
          entity: 'Invoice',
          module: 'Sales',
          displayField: 'invoiceNumber',
          label: 'Invoices',
          labelKey: 'Menu:Sales.Invoice',
          path: '/sales/invoices',
          order: 20,
          viewType: 'list',
          permission: 'Sales.Invoice.ViewMenu',
        }
        ],
      },
      {
        id: 'records',
        label: 'Masterdata',
        labelKey: 'Menu:Sales.Category.Masterdata',
        icon: AccountBox,
        order: 2,
        items: [
        {
          id: 'customer',
          entity: 'Customer',
          module: 'Sales',
          displayField: 'customerNumber',
          label: 'Customers',
          labelKey: 'Menu:Sales.Customer',
          path: '/sales/customers',
          icon: People,
          order: 10,
          viewType: 'list',
          permission: 'Sales.Customer.ViewMenu',
        },
        {
          id: 'customergroup',
          entity: 'CustomerGroup',
          module: 'Sales',
          displayField: 'name',
          label: 'Customer Groups',
          labelKey: 'Menu:Sales.CustomerGroup',
          path: '/sales/customergroups',
          icon: Groups,
          order: 12,
          viewType: 'list',
          permission: 'Sales.CustomerGroup.ViewMenu',
        }
        ],
      },
      {
        id: 'inquiries',
        label: 'Inquiries',
        labelKey: 'Menu:Sales.Category.Inquiries',
        icon: Search,
        order: 3,
        items: [
        {
          id: 'order_inquiry',
          entity: 'Order',
          module: 'Sales',
          displayField: 'orderNumber',
          label: 'Order History',
          labelKey: 'Menu:Sales.OrderHistory',
          path: '/sales/orders?preset=last30Days',
          order: 10,
          viewType: 'inquiry',
          permission: 'Sales.Order.ViewMenu',
        }
        ],
      },
      {
        id: 'settings',
        label: 'Settings',
        labelKey: 'Menu:Sales.Category.Settings',
        icon: Settings,
        order: 99,
        items: [

        ],
      }
    ],
  },
  {
    module: 'TaskManagement',
    label: 'TaskManagement',
    labelKey: 'Menu:TaskManagement',
    icon: TaskAlt,
    quickActions: [],
    categories: [
      {
        id: 'workflow',
        label: 'Workflow',
        labelKey: 'Menu:TaskManagement.Category.Workflow',
        icon: AccountTree,
        order: 1,
        items: [
        {
          id: 'worktask',
          entity: 'WorkTask',
          module: 'TaskManagement',
          displayField: 'workflowName',
          label: 'Task Inbox',
          labelKey: 'Menu:TaskManagement.WorkTask',
          path: '/taskmanagement/inbox',
          icon: Inbox,
          order: 10,
          viewType: 'list',
          permission: 'TaskManagement.WorkTask.ViewMenu',
          landingPage: true,
        }
        ],
      },
      {
        id: 'settings',
        label: 'Settings',
        labelKey: 'Menu:TaskManagement.Category.Settings',
        icon: Settings,
        order: 99,
        items: [
        {
          id: 'worktask_list',
          entity: 'WorkTask',
          module: 'TaskManagement',
          displayField: 'workflowName',
          label: 'Work Tasks (Admin)',
          labelKey: 'Menu:TaskManagement.WorkTasks(Admin)',
          path: '/taskmanagement/worktasks',
          icon: AdminPanelSettings,
          order: 10,
          viewType: 'list',
          permission: 'TaskManagement.WorkTask.Update',
        }
        ],
      }
    ],
  },
  {
    module: 'Workflow',
    label: 'Workflow',
    labelKey: 'Menu:Workflow',
    icon: AccountTree,
    quickActions: [],
    categories: [
      {
        id: 'workflow',
        label: 'Workflow',
        labelKey: 'Menu:Workflow.Category.Workflow',
        icon: Folder,
        order: 50,
        items: [
        {
          id: 'approvalrequest',
          entity: 'ApprovalRequest',
          module: 'Workflow',
          displayField: 'requestNumber',
          label: 'Approval Requests',
          labelKey: 'Menu:Workflow.ApprovalRequest',
          path: '/workflow/approvalrequests',
          icon: Approval,
          order: 10,
          viewType: 'list',
          permission: 'Workflow.ApprovalRequest.ViewMenu',
        },
        {
          id: 'approvalpolicy',
          entity: 'ApprovalPolicy',
          module: 'Workflow',
          displayField: 'name',
          label: 'Approval Policies',
          labelKey: 'Menu:Workflow.ApprovalPolicy',
          path: '/workflow/approvalpolicies',
          icon: Policy,
          order: 20,
          viewType: 'list',
          permission: 'Workflow.ApprovalPolicy.ViewMenu',
        },
        {
          id: 'approvaldelegation',
          entity: 'ApprovalDelegation',
          module: 'Workflow',
          displayField: 'fromUserName',
          label: 'Delegations',
          labelKey: 'Menu:Workflow.ApprovalDelegation',
          path: '/workflow/approvaldelegations',
          icon: SwapHoriz,
          order: 30,
          viewType: 'list',
          permission: 'Workflow.ApprovalDelegation.ViewMenu',
        }
        ],
      },
      {
        id: 'settings',
        label: 'Settings',
        labelKey: 'Menu:Workflow.Category.Settings',
        icon: Settings,
        order: 99,
        items: [

        ],
      }
    ],
  }
];

/**
 * Get navigation for a specific module
 */
export function getModuleNavigation(moduleName: string): ModuleNavigationConfig | undefined {
  return moduleNavigation.find(m => m.module === moduleName);
}

/**
 * Get all module names
 */
export function getAllModules(): string[] {
  return moduleNavigation.map(m => m.module);
}

/**
 * Get all navigation items for a module (flattened)
 */
export function getModuleItems(moduleName: string): NavigationMenuItem[] {
  const module = getModuleNavigation(moduleName);
  if (!module) return [];

  return module.categories.flatMap(cat => cat.items);
}

/**
 * Find a navigation item by path
 */
export function findItemByPath(path: string): NavigationMenuItem | undefined {
  for (const module of moduleNavigation) {
    for (const category of module.categories) {
      const item = category.items.find(i => i.path === path);
      if (item) return item;
    }
  }
  return undefined;
}
